import { Box, Divider, Grid, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useAuthContext } from 'src/context/AuthContextProvider';
import { FiagroResumeData } from 'src/types/operations/fiagro';
import { Media } from 'src/types/strapi';

import CardServiceProvider from '../../../../../components/CardServiceProvider';

type OperationFIAGROResumeServiceProviderProps = {
  data?: Pick<
    FiagroResumeData['serviceProviders'],
    'administrators' | 'managers' | 'auditors'
  >;
};

function CardServiceProviderWrap({
  title,
  name,
  logo,
  cnpj,
}: {
  title: string;
  name?: string;
  logo?: Media;
  cnpj: string;
}) {
  const data = {
    findInstitutionByCnpj: {
      slug: 'fiagro',
      hashId: '1234567890',
    },
  };

  return (
    <Link
      component={RouterLink}
      underline="none"
      to={`/instituicao/${data.findInstitutionByCnpj?.slug}/${data.findInstitutionByCnpj?.hashId}`}>
      <CardServiceProvider title={title} name={name ?? ''} logo={logo} link />
    </Link>
  );
}

export default function OperationFIAGROResumeServiceProvider({
  data,
}: OperationFIAGROResumeServiceProviderProps) {
  const { auth } = useAuthContext();

  const canViewServiceProviders =
    auth?.user?.subscription?.plan?.permissions
      ?.operacoes_fiagro_prestadores_de_servicos;

  return (
    <Box p={1}>
      <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
        &mdash;Prestadores de Serviço
      </Typography>
      <Divider sx={{ height: 2, backgroundColor: 'black' }} />
      <Box py={4}>
        <Grid container spacing={1}>
          {data?.administrators?.length &&
            data?.administrators?.length > 0 &&
            data?.administrators?.map(({ logo, name, cnpj }) => (
              <Grid item xs={12} sm={6} md={12} lg={6} key={cnpj}>
                <CardServiceProviderWrap
                  title="Administrador"
                  logo={logo}
                  name={name ?? ''}
                  cnpj={cnpj}
                />
              </Grid>
            ))}
          {data?.managers?.length &&
            data?.managers?.length > 0 &&
            data?.managers?.map(({ logo, name, cnpj }) => (
              <Grid item xs={12} sm={6} md={12} lg={6} key={cnpj}>
                <CardServiceProvider
                  alert={!canViewServiceProviders}
                  lock={!canViewServiceProviders}
                  title="Gestor"
                  logo={logo}
                  name={name ?? ''}
                />
              </Grid>
            ))}
        </Grid>
      </Box>
    </Box>
  );
}
